import { z } from "zod"
import { ChildrenContainerOptionsV1, ContainerOptionsV1 } from "../containerOptions"
import { Element } from "../element"

// Version 1 ---------------------
export const ListSettingsV1 = z.object({
  horizontal: z.union([z.literal(true), z.literal(false)]),
  snap: z.union([z.literal(true), z.literal(false)]),
  fullHeight: z.union([z.literal(true), z.literal(false)]),
  height: z.string(),
  indicatorBottomPadding: z.union([z.literal(true), z.literal(false)]),
  indicatorTopPadding: z.union([z.literal(true), z.literal(false)]),
  indicatorColor: z.string(),
  style: z.string(),
})

export type TListSettingsV1 = z.infer<typeof ListSettingsV1>

export const ListElementV1 = z.object({
  id: z.string(),
  name: z.literal("list"),
  settings: ListSettingsV1,
  container: ContainerOptionsV1,
  children: z.lazy(() => z.array(Element)),
  childrenContainer: ChildrenContainerOptionsV1,
})

export type TListElementV1 = z.infer<typeof ListElementV1>

// Version 2 ---------------------
export const ListSettingsV2 = z.object({
  horizontal: z.union([z.literal(true), z.literal(false)]),
  snap: z.union([z.literal(true), z.literal(false)]),
  hasItemPadding: z.union([z.literal(true), z.literal(false)]),
  fullHeight: z.union([z.literal(true), z.literal(false)]),
  height: z.string(),
  indicatorBottomPadding: z.union([z.literal(true), z.literal(false)]),
  indicatorTopPadding: z.union([z.literal(true), z.literal(false)]),
  indicatorColor: z.string(),
  style: z.string(),
})

export type TListSettingsV2 = z.infer<typeof ListSettingsV2>

export const ListElementV2 = z.object({
  id: z.string(),
  name: z.literal("list"),
  settings: ListSettingsV1,
  container: ContainerOptionsV1,
  children: z.lazy(() => z.array(Element)),
  childrenContainer: ChildrenContainerOptionsV1,
})

export type TListElementV2 = z.infer<typeof ListElementV2>

// Latest ---------------------
export const ListSettings = ListSettingsV2
export type TListSettings = TListSettingsV2
export const ListElement = ListElementV2
export type TListElement = TListElementV2
